export default "__VITE_ASSET__9DDfK04j__"